import { browserHistory } from 'react-router';

export { browserHistory as history };
